import {
  STORE_CSP,
  STORE_CustomerName,
  STORE_DineType,
  STORE_MTYPE,
  STORE_PhoneNo,
  STORE_SelectedMerchantProduct,
  STORE_ZoneDescription,
  STORE_ZoneId,
  STORE_dtoMobileSettings,
  TEMP_STORE_CustomerName,
  TEMP_STORE_PhoneNo,
  TEMP_STORE_CSID,
  STORE_Cart,
  STORE_CSID,
  STORE_dtoCustomerAddressList,
  STORE_CustomerDefaultAddress,
  STORE_Addons,
  STORE_DeliveryZoneID,
  STORE_FinaleSelelctCartMerchantNZone,
  STORE_SHEDULEDateNTime,
  STORE_CartCheckoutData,
  STORE_NIC,
  STORE_PUSHTOKEN,
  STORE_DeviceInfo,
  TEMP_STORE_OTP,
  STORE_StartingNo,
  STORE_PAGE_URL,
  STORE_MobileCordinates,
  STORE_HardReleaseVersion,
  STORE_Division_details,
  PUSHNOTIFICATIONURL,
} from "./store-names";
import {
  set_dto_selected_final_merchant_or_product,
  set_dto_selected_merchant_or_product,
  set_dto_StartupPageLoadInfo,
  set_dto_checkout_data_store,
} from "../classes/dto-setters/dto-setter";
import { dto_Customer, dto_CustomerAddress } from "../classes/dto-customer";
import { ENCRYPT_STORAGE, SET_STARTUP } from "../config/config";
import { api_checkAppStoreVersion } from "../connection/api/api-home";
import { dto_cart_checkout } from "../classes/dto-cart-checkout";
import { CLEAR_STORE } from "./clear-store";
import { GET_CART_MEMORY_CACHE, SET_CART_MEMORY_CACHE } from "./store-data";
import { resolveAddressPhoneNo } from "../functions/address-phone";
import { SET_COLORS } from "../util/color-config";
import { dto_common } from "../classes/dto-common";
import { PT_STARTUP } from "../routes/stack/paths/pt-home";
import { isMobile } from "react-device-detect";
import {
  decryptCartStorageData,
  decryptCheckoutStorageData,
} from "../functions/store_sessions";
var $ = require("jquery");

export const GET_SET_STORED_DATA = async () => {
  let results = false;

  let l = ENCRYPT_STORAGE.getMultipleItems([
    STORE_dtoMobileSettings,
    STORE_CSP,
    STORE_DineType,
    STORE_ZoneId,
    STORE_ZoneDescription,
    STORE_MTYPE,
    "ar3Mad32u4faTSrAUla",
    STORE_HardReleaseVersion,
  ]);
  if (l[STORE_CSP] !== undefined) {
    let Version = l[STORE_HardReleaseVersion];
    if (Version !== undefined) {
      await SET_STARTUP({ csp: l[STORE_CSP], HardReleaseVersion: Version });
    } else {
      await SET_STARTUP({ csp: l[STORE_CSP], HardReleaseVersion: undefined });
    }

    await SET_COLORS({ CSP: l[STORE_CSP] });
    dto_common.CSP = l[STORE_CSP];
    results = true;
  } else {
    results = false;
  }
  if (l[STORE_dtoMobileSettings] !== undefined) {
    set_dto_StartupPageLoadInfo(l[STORE_dtoMobileSettings]);
    results = true;
  } else {
    results = false;
  }
  if (l[STORE_DineType] !== undefined) {
    dto_common.DineType = l[STORE_DineType];
    results = true;
  } else {
    results = false;
  }
  if (l[STORE_ZoneId] !== undefined) {
    dto_common.ZoneId = l[STORE_ZoneId];
    dto_common.ZoneDescription = l[STORE_ZoneDescription];
    results = true;
  } else {
    results = false;
  }
  if (l[STORE_MTYPE] !== undefined) {
    dto_common.MTYPE = l[STORE_MTYPE];
  } else {
    results = false;
  }

  await SET_VALUES_FROM_STORE_ON_START();
  if (results === false) {
    if (l[STORE_CSP] !== undefined) {
      window.location.href = "/" + l[STORE_CSP];
    } else {
      window.location.href = "/";
    }
  }
  if (l["ar3Mad32u4faTSrAUla"] !== undefined) {
    dto_common.MemmoryURl = l["ar3Mad32u4faTSrAUla"];
  } else {
    await VERSION_CHECK();
  }

  return results;
};

export const SET_VALUES_FROM_STORE_ON_START = async () => {
  let l = ENCRYPT_STORAGE.getMultipleItems([
    STORE_SelectedMerchantProduct,
    STORE_CSID,
    STORE_CustomerName,
    STORE_PhoneNo,
    STORE_CustomerDefaultAddress,
    STORE_DeliveryZoneID,
    STORE_FinaleSelelctCartMerchantNZone,
    STORE_CartCheckoutData,
    STORE_NIC,
    STORE_PUSHTOKEN,
    STORE_DeviceInfo,
    STORE_SHEDULEDateNTime,
    STORE_MobileCordinates,
  ]);
  //#region STORE_CSID
  if (l[STORE_CSID] !== undefined) {
    dto_Customer.CSID = l[STORE_CSID];
  } else {
    dto_Customer.CSID = 0;
  }
  //#endregion
  //#region STORE_PUSHTOKEN
  if (l[STORE_PUSHTOKEN] !== undefined) {
    dto_Customer.PushToken = l[STORE_PUSHTOKEN];
  } else {
    dto_Customer.PushToken = 0;
  }
  //#endregion
  //#region STORE_DeviceInfo
  if (l[STORE_DeviceInfo] !== undefined) {
    dto_Customer.DeviceInfo = l[STORE_DeviceInfo];
  } else {
    dto_Customer.DeviceInfo = 0;
  }
  //#endregion
  //#region STORE_DeviceInfo
  if (l[STORE_MobileCordinates] !== undefined) {
    dto_common.MobileCordinate = l[STORE_MobileCordinates];
  } else {
    dto_common.MobileCordinate = "";
  }
  //#endregion
  //#region STORE_NIC
  if (l[STORE_NIC] !== undefined) {
    dto_Customer.NIC = l[STORE_NIC];
  } else {
    dto_Customer.NIC = 0;
  }
  //#endregion

  //#region STORE_CustomerName
  if (l[STORE_CustomerName] !== undefined) {
    dto_Customer.CusName = l[STORE_CustomerName];
  } else {
    dto_Customer.CusName = "";
  }
  //#endregion
  //#region STORE_PhoneNo
  if (l[STORE_PhoneNo] !== undefined) {
    dto_Customer.PhoneNo = l[STORE_PhoneNo];
  } else {
    dto_Customer.PhoneNo = "";
  }
  //#endregion
  //#region STORE_CustomerDefaultAddress
  if (l[STORE_CustomerDefaultAddress] !== undefined) {
    dto_CustomerAddress.DefaultAdd1 =
      l[STORE_CustomerDefaultAddress].DefaultAdd1;
    dto_CustomerAddress.DefaultAdd2 =
      l[STORE_CustomerDefaultAddress].DefaultAdd2;
    dto_CustomerAddress.DefaultAdd3 =
      l[STORE_CustomerDefaultAddress].DefaultAdd3;
    dto_CustomerAddress.AddressGuid =
      l[STORE_CustomerDefaultAddress].AddressGuid;
    dto_CustomerAddress.PhoneNo = resolveAddressPhoneNo(
      l[STORE_CustomerDefaultAddress],
    );
    dto_CustomerAddress.Location = l[STORE_CustomerDefaultAddress].Location;
    dto_common.CurrentCordinate = l[STORE_CustomerDefaultAddress].Location;
  } else {
    dto_CustomerAddress.DefaultAdd1 = "";
    dto_CustomerAddress.DefaultAdd2 = "";
    dto_CustomerAddress.DefaultAdd3 = "";
    dto_CustomerAddress.AddressGuid = "";
    dto_CustomerAddress.PhoneNo = "";
    dto_CustomerAddress.Location = "0,0";
    dto_common.CurrentCordinate = "0,0";
  }
  //#endregion
  //#region STORE_DeliveryZoneID
  if (l[STORE_DeliveryZoneID] !== undefined) {
    dto_common.DeliveryZoneID = l[STORE_DeliveryZoneID];
  } else {
    dto_common.DeliveryZoneID = 0;
  }
  //#endregion
  //#region STORE_SelectedMerchantProduct
  if (l[STORE_SelectedMerchantProduct] !== undefined) {
    set_dto_selected_merchant_or_product(l[STORE_SelectedMerchantProduct]);
  }
  //#endregion
  //#region STORE_FinaleSelelctCartMerchantNZone
  if (l[STORE_FinaleSelelctCartMerchantNZone] !== undefined) {
    set_dto_selected_final_merchant_or_product(
      l[STORE_FinaleSelelctCartMerchantNZone],
    );
  }
  //#endregion
  //#region STORE_SHEDULEDateNTime
  if (l[STORE_SHEDULEDateNTime] !== undefined) {
    dto_common.SCHEDULEDDATE = l[STORE_SHEDULEDateNTime].date;
    dto_common.SCHEDULEDTIME = l[STORE_SHEDULEDateNTime].time;
  } else {
    dto_common.SCHEDULEDDATE = "";
    dto_common.SCHEDULEDTIME = "";
  }
  //#endregion
  //#region STORE_CartCheckoutData
  if (l[STORE_CartCheckoutData] !== undefined) {
    set_dto_checkout_data_store(
      decryptCheckoutStorageData(l[STORE_CartCheckoutData]),
    );
  } else {
    dto_cart_checkout.DiscountPersentage = 0;
    dto_cart_checkout.DiscountTotal = 0;
    dto_cart_checkout.PromoGuid = 0;
    dto_cart_checkout.PromoCODE = 0;
  }

  //#endregion
  if (isMobile) {
    $("html,body").animate(
      {
        scrollTop: 0,
      },
      0,
    );
  } else {
    $(".WindowDevice").animate(
      {
        scrollTop: 0,
      },
      0,
    );
  }
};

export const VERSION_CHECK = async () => {
  let data = await api_checkAppStoreVersion();
  let objData = JSON.parse(data);
  if (objData === "UPDATE") {
    let csp = await CLEAR_STORE();
    if (csp === undefined) {
      window.location.href = "/";
    } else {
      window.location.href = PT_STARTUP.replace(":csp", csp);
    }
  } else {
    dto_common.MemmoryURl = JSON.parse(data);
  }
};

export const Get_PhoneNo = async () => {
  return ENCRYPT_STORAGE.getItem(STORE_PhoneNo);
};
export const Get_CustomerName = async () => {
  return ENCRYPT_STORAGE.getItem(STORE_CustomerName);
};

export const Temp_Get_CustomerName = async () => {
  return ENCRYPT_STORAGE.getItem(TEMP_STORE_CustomerName);
};

export const Temp_Get_CustomerCSID = async () => {
  return ENCRYPT_STORAGE.getItem(TEMP_STORE_CSID);
};

export const Temp_Get_CustomerPhoneNO = async () => {
  return ENCRYPT_STORAGE.getItem(TEMP_STORE_PhoneNo);
};

export const Temp_Get_OTP = async () => {
  return ENCRYPT_STORAGE.getItem(TEMP_STORE_OTP);
};

export const Get_CustomerCSID = async () => {
  return ENCRYPT_STORAGE.getItem(STORE_CSID);
};

export const Get_CustomerAddressList = async () => {
  let AddressList = ENCRYPT_STORAGE.getItem(STORE_dtoCustomerAddressList);
  if (AddressList !== undefined) {
    return AddressList.dtoAddressList;
  } else {
    return [];
  }
};
export const Get_CustomerDefaultAddress = async () => {
  let Address = ENCRYPT_STORAGE.getItem(STORE_CustomerDefaultAddress);
  if (Address !== null && Address !== undefined) {
    let GroupAddress =
      Address.DefaultAdd1 +
      ", " +
      Address.DefaultAdd2 +
      ", " +
      Address.DefaultAdd3;
    return GroupAddress;
  } else {
    return "Select your address";
  }
};

export const GET_CART = async () => {
  const cachedCart = GET_CART_MEMORY_CACHE();
  if (cachedCart !== undefined) {
    return Array.isArray(cachedCart) ? [...cachedCart] : cachedCart;
  }

  const storedCart = decryptCartStorageData(ENCRYPT_STORAGE.getItem(STORE_Cart));
  SET_CART_MEMORY_CACHE(storedCart);
  return storedCart;
};

export const GET_ADDON_UOM = async () => {
  return ENCRYPT_STORAGE.getItem(STORE_Addons);
};

export const GET_SELECTED_MERCHANT_OR_PRODCUCT = () => {
  return ENCRYPT_STORAGE.getItem(STORE_SelectedMerchantProduct);
};

export const GET_CART_SELECT_MERCHATS_ZONE = async () => {
  return ENCRYPT_STORAGE.getItem(STORE_FinaleSelelctCartMerchantNZone);
};

export const GET_CART_CHECKOUT_DATE = async () => {
  return decryptCheckoutStorageData(
    ENCRYPT_STORAGE.getItem(STORE_CartCheckoutData),
  );
};

export const GET_STARTING_NO = async () => {
  return ENCRYPT_STORAGE.getItem(STORE_StartingNo);
};

export const GET_DELIVERY_ZONEID = async () => {
  return ENCRYPT_STORAGE.getItem(STORE_DeliveryZoneID);
};

export const GET_CSP = async () => {
  return ENCRYPT_STORAGE.getItem(STORE_CSP);
};

export const GET_PAGE_URL = async () => {
  return ENCRYPT_STORAGE.getItem(STORE_PAGE_URL);
};

export const GET_DIVISION_DETAILS = async () => {
  return ENCRYPT_STORAGE.getItem(STORE_Division_details);
};

export const GET_PUSHNOTIFICATION_REDIRECT_URL = async () => {
  var URL = ENCRYPT_STORAGE.getItem(PUSHNOTIFICATIONURL);
  ENCRYPT_STORAGE.removeItem(PUSHNOTIFICATIONURL);
  return URL;
};
